import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import '../../styles/default.scss';

class Footer extends React.Component{
	constructor (props) {
		super(props);
		this.state={
		}
	}
	componentWillMount () {
	}
	render() {
		return(
			<div className='app-footer'>

        <div className='footer-top home-contain'>
            <div className="content">
          <img className='icon-hui' src={`${process.env.PUBLIC_URL}/images/logo-hui.png`} alt="传媒" />
          <div className='phone-group'>
            <div className='footer-title'>
              <i className='glyphicon glyphicon-phone'></i> 客服电话
            </div>
            <span>杭州亦盛：400-9997360</span>
            <span>上海亦盛：400-9636889</span>
          </div>
          <div className='phone-group' style={{marginLeft: '104px'}}>
            <div className='footer-title'>
              <i className='glyphicon glyphicon-address'></i> 公司地址
            </div>
            <span>杭州亦盛：杭州市西湖区西园一路18号浙大网新软件园A座5F</span>
            <span>上海亦盛：上海市嘉定区金运路355号华泰中心12C，13F</span>
            <span>深圳亦盛：广东省深圳市南山区高新南九道10号深圳湾科技生态园10栋701-B1</span>
          </div>
          <div className='phone-group' style={{marginLeft: '60px'}}>
            <div className='footer-title' style={{marginBottom: '20px'}}>
              关注我们
            </div>
            <img className='icon-erwei' src={`${process.env.PUBLIC_URL}/images/wechat.jpg`} alt="亦盛" />
          </div>
            </div>
         </div>
        <div className='footer-bottom text-center'>
            <div className="content">Copyright©2018  <a href="https://beian.miit.gov.cn" target="_blank">浙ICP备18034406号</a>   <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602012491" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/police.png`} alt="" /> 浙公网安备 33010602012491号</a>  亦盛传媒  版权所有 </div>
        </div>

			</div>
		)
	}
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/widget/footer.jsx